export const displayName: string = 'Omaze:Feature';
